import { BannerInfo } from "@mezo-org/mezo-clay"

import {
  selectHasLoadedTransactions,
  selectIsConnected,
  selectUnbridgedDeposits,
  useDappSelector,
} from "#/redux-state"

import OverviewSection from "./OverviewSection"
import OverviewUnbridgedAssetsItem from "./OverviewUnbridgedAssetsItem"

export default function OverviewUnbridgedAssets() {
  const deposits = useDappSelector(selectUnbridgedDeposits)
  const hasLoadedTransactions = useDappSelector(selectHasLoadedTransactions)
  const isConnected = useDappSelector(selectIsConnected)

  if (!isConnected || (hasLoadedTransactions && !deposits.length)) return null

  return (
    <OverviewSection
      header="Unbridged Assets"
      isLoading={!hasLoadedTransactions}
    >
      {hasLoadedTransactions && (
        <BannerInfo
          artworkType="icon"
          overrides={{ Root: { style: () => ({ marginInline: 0 }) } }}
        >
          Please bridge your assets to Mezo mainnet or withdraw to your wallet.
        </BannerInfo>
      )}
      {deposits.map((deposit) => (
        <OverviewUnbridgedAssetsItem
          key={deposit.depositId}
          deposit={deposit}
        />
      ))}
    </OverviewSection>
  )
}
